import React, { useLayoutEffect } from "react";
//import styled from "styled-components";
import MabaniNav from "./MabaniNav";
import "./mabaniVariables.scss";

const MabaniLayout = ({ children }) => {
  
  return (
    <>
      <MabaniNav />
      <>
        {children}
      </>
    </>
  )
};
export default MabaniLayout;
/*
const StyledMabaniContent = styled.div`
  position: relative;
  color: var(--theme-text-against-dark);
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 100vw;
    margin-left: -50vw;
    background-color: inherit;
    z-index: -1;
  background-color: var(--theme-background-dark);
  }
`;
*/